<template>
  <div>
    <div class="card-grid mt-4">
      <div class="card with-padding with-shadow details">
        <div class="d-flex justify-content-between align-items-baseline">
          <h2 class="title">
            Main Driver
          </h2>
          <a href="#" aria-label="Edit" @click.prevent="editProfile()">Edit</a>
        </div>
        <ul>
          <li class="d-block"><span class="key d-block">Name:</span><span class="value d-block">{{ profile.fullName }}</span></li>
          <li class="d-block"><span class="key d-block">Email Address:</span><span class="value d-block">{{ profile.emailAddress }}</span></li>
          <li class="d-block" v-if="showMainDriverDrivingLicense"><span class="key d-block">Driving License #:</span><span class="value d-block">{{ driverLicense(profile) }}</span></li>
        </ul>
      </div>

      <div class="card with-padding with-shadow details" v-for="additionalDriver, key in profile.additionalDrivers">
        <div class="d-flex justify-content-between align-items-baseline">
          <h2 class="title">
            {{ key === 0 ? "Additional Driver 1" : "Additional Driver 2" }}
          </h2>
          <a href="#" aria-label="Edit" @click.prevent="showExistingAdditionalDriverForm(key)">Edit</a>
        </div>
        <ul>
          <li class="d-block"><span class="key d-block">Name:</span><span class="value d-block">{{ additionalDriver.fullName }}</span></li>
          <li class="d-block"><span class="key d-block">Email Address:</span><span class="value d-block">{{ additionalDriver.emailAddress }}</span></li>
          <li class="d-block" v-if="(key === 0 && showAdditionalDriver1DrivingLicense) || (key === 1 && showAdditionalDriver2DrivingLicense)"><span class="key d-block">Driving License #:</span><span
            class="value d-block">{{ driverLicense(additionalDriver) }}</span></li>
        </ul>
      </div>

      <div class="card with-padding details d-flex justify-content-center" v-if="profile.additionalDrivers && (profile.additionalDrivers.length < maxAdditionalDrivers)">
        <a href="" aria-label="Add additional driver" class="add-additional-driver align-self-center" @click.prevent="showNewAdditionalDriverForm">
          <div class="add-symbol">＋</div>
          Add additional driver
        </a>
      </div>
    </div>

    <div class="slideout"
      :class="{ 'slideout--show' : slideoutVisible }">

      <div v-if="slideoutVisible">

        <!-- Header -->
        <div class="row">
          <div class="col-10 text-start">
            <div>
              <h3><span>{{ additionalDriverTitle }}</span></h3>

              <form method="POST" @submit.prevent="submitAdditionalDriverForm" id="edit-additional-driver-form">

                <input v-if="payload.additionalDriverID" type="hidden" name="additional_driver_id" v-model="payload.additionalDriverID">

                <h6>Name:</h6>

                <div class="row mb-4">
                  <div class="col-6">
                    <div class="input firstname">
                      <input type="text" class="firstname" name="firstname" id="additional-driver-firstname" v-model="payload.firstname" required>
                      <label for="additional-driver-firstname">Firstname</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="input surname">
                      <input type="text" class="surname" name="surname" id="additional-driver-surname" v-model="payload.surname" required>
                      <label for="additional-driver-surname">Surname</label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <div class="input email">
                      <input type="email" class="email" name="email" id="additional-driver-email" v-model="payload.email" required>
                      <label for="additional-driver-email">Additional Driver Email</label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4" v-if="showAdditionalDriverSlideoutDrivingLicenseField">
                  <div class="col-12">
                    <div class="input driving-license">
                      <input type="text" class="driving-license" name="driving_license" id="additional-driver-driving-license" v-model="payload.drivingLicense" required>
                      <label for="additional-driver-driving-license">Driving License #:</label>
                    </div>
                  </div>
                </div>

                <input type="submit" value="Save" class="button button--steelBlue float-end">
                <button v-if="payload.additionalDriverID" class="button button--remove float-end me-2" @click.prevent="deleteAdditionalDriver">Delete Driver</button>

              </form>
            </div>
          </div>
          <div class="col-2 text-end">
            <button @click="hideSlideout" class="close"><i class="icon-cross"></i></button>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>

import {EventBus} from '@/event-bus.js';

export default {
  name: 'bch-your-profile-scheme-details-component',
  props: [
    'profile',
    'product',
    'scheme',
    'schemeId',
    'adminPortalData',
  ],

  data() {
    return {
      slideoutVisible: false,
      payload: {
        additionalDriverID: null,
        firstname: null,
        surname: null,
        email: null,
        mainDriver: null,
        drivingLicense: null,
      },
    }
  },

  mounted() {
    EventBus.$on('yourProfileCompleted', (profileCompleted) => {

    });
  },

  computed: {
    showMainDriverDrivingLicense() {
      return this.adminPortalData?.content?.products?.bch[0].display_settings_show_driving_license_main_driver;
    },

    showAdditionalDriver1DrivingLicense() {
      return this.adminPortalData?.content?.products?.bch[0].display_settings_show_driving_license_additional_driver_1;
    },

    showAdditiona2Driver1DrivingLicense() {
      return this.adminPortalData?.content?.products?.bch[0].display_settings_show_driving_license_additional_driver_2;
    },

    additionalDriverTitle() {
      return this.profile.additionalDrivers && (this.profile.additionalDrivers.length === 0) ? this.product.scheme_card_additional_driver_one_heading_text : this.product.scheme_card_additional_driver_two_heading_text;
    },

    maxAdditionalDrivers() {
      return parseInt(this.product.maximum_additional_drivers);
    },

    showAdditionalDriverSlideoutDrivingLicenseField() {
      if (this.payload.additionalDriverID) {
        let index = 0;
        this.profile.additionalDrivers.forEach((additionalDriver, idx) => {
          if (additionalDriver.id === this.payload.additionalDriverID) {
            index = idx;
          }
        });
        return index === 0 ? this.showAdditionalDriver1DrivingLicense : this.showAdditiona2Driver1DrivingLicense;
      } else {
        return this.profile.additionalDrivers && (this.profile.additionalDrivers.length === 1) ? this.showAdditionalDriver1DrivingLicense : this.showAdditiona2Driver1DrivingLicense;
      }
    },

  },

  methods: {
    showSlideout() {
      this.slideoutVisible = true;
    },

    hideSlideout() {
      this.slideoutVisible = false;
    },

    showNewAdditionalDriverForm() {
      this.payload = {
        additionalDriverID: null,
        firstname: null,
        surname: null,
        email: null,
        mainDriver: false,
        drivingLicense: null,
        scheme: 'bch',
      }

      this.showSlideout();
    },

    showExistingAdditionalDriverForm(index) {
      const additionalDriver = this.profile.additionalDrivers[index];

      if (additionalDriver) {
        this.payload = {
          additionalDriverID: additionalDriver.id,
          firstname: additionalDriver.forename,
          surname: additionalDriver.surname,
          email: additionalDriver.emailAddress,
          mainDriver: false,
          drivingLicense: additionalDriver.driverLicence.licenceNumber,
          scheme: 'bch',
        }

        this.showSlideout();
      }
    },

    submitAdditionalDriverForm() {
      EventBus.$emit('loading', true);
      let interval = 1000;
      let messages = [
        'Saving Additional Driver',
      ];
      messages.forEach((message, index) => {
        setTimeout(() => {
          EventBus.$emit('loadingTitle', message);
        }, index * interval);
      });

      this.$http.post('/api/save-additional-driver', this.payload)
        .then(response => {
          EventBus.$emit('loading', false);

          this.$notify({
            group: 'notify',
            type: 'success',
            title: 'Success',
            text: 'Additional Driver saved successfully'
          });

          this.payload.additionalDriverID = response.data.data.id;

          this.hideSlideout();

          EventBus.$emit('reload-driver-profile');
        })
        .catch(err => {
          EventBus.$emit('loading', false);
          let response = err.response.data;

          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: response.error.message
          });
        });
    },

    driverLicense(driver) {
      return driver.driverLicence?.licenceNumber;
    },

    editProfile() {
      EventBus.$emit('editProfile');
    },

    deleteAdditionalDriver() {
      EventBus.$emit('loading', true);
      let interval = 1000;
      let messages = [
        'Deleting Additional Driver',
        'Recalculating quotes',
      ];
      messages.forEach((message, index) => {
        setTimeout(() => {
          EventBus.$emit('loadingTitle', message);
        }, index * interval);
      });

      this.$http.post('/api/delete-additional-driver', this.payload)
        .then(response => {
          EventBus.$emit('loading', false);

          this.$notify({
            group: 'notify',
            type: 'success',
            title: 'Success',
            text: 'Additional Driver deleted successfully'
          });

          this.payload.additionalDriverID = null;

          this.hideSlideout();

          EventBus.$emit('reload-driver-profile');
        })
        .catch(err => {
          EventBus.$emit('loading', false);
          let response = err.response.data;

          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: response.error.message
          });
        });
    },
  },
}
</script>

